import apiClient from '../Api/axiosConfig';

const trackEvent = (eventType, details = {}) => {
    apiClient.post('/analytics/track', {eventType, details}).catch(error => { console.error("Analytics tracking error:", error); });
};

export default trackEvent;